import type { ResultPayload } from "@mesketch/engine";
import type { OfflineBundle } from "./api.js";
import type { Answers } from "./device.js";

// Náhled výsledku kola bez připojení (REQ-022 AK 3, NFR-003): tentýž engine nad definicí
// a normami uloženými v zařízení, se semínkem sezení. Engine se načte jen tady (samostatný blok),
// online ho klient nikdy nespouští (DEC-006, REQ-022 AK 2).

/** Počet výpočtů enginem v klientu: E2E ověří, že online je nula (REQ-022 AK 2). */
declare global {
  var __mesketchEngineRuns: number | undefined;
}

export async function offlineRoundResult(bundle: OfflineBundle, sessionId: string, round: number, answers: Readonly<Answers>): Promise<ResultPayload> {
  const engine = await import("@mesketch/engine");
  globalThis.__mesketchEngineRuns = (globalThis.__mesketchEngineRuns ?? 0) + 1;
  const definition = engine.methodologyDefinition.parse(bundle.definition);
  return engine.computeResult({
    definition,
    definitionHash: bundle.definitionHash,
    norms: bundle.norms === null ? null : engine.normStats.parse(bundle.norms),
    responses: Object.entries(answers)
      .filter(([, a]) => a.round <= round)
      .map(([itemId, a]) => ({ itemId, value: a.value, durationMs: a.durationMs })),
    respondent: { sex: null, age: null },
    extraOrdinals: [],
    scope: { kind: "round", round },
    seed: { session: sessionId },
  });
}
